import { CheckBox } from "@portal/BaseComponents/CheckBox/AntCheckBox";
import { onCheckBoxChange } from "@portal/BaseComponents/CheckBox/type";
import { PopConfirm } from "@portal/BaseComponents/PopConfirm/AntPopConfirm";
import { PopConfirmContent } from "@portal/BaseComponents/PopConfirm/PopConfirmContent";
import { useState } from "react";

const t = {
  label: "Include Invoices",
  title: "Do you want to continue?",
  desc: "Unchecking this will remove invoices added below and allow you to create PTP without specifying invoices.",
  yes: "Yes",
  no: "No",
};

interface AgainstInvoicesCheckboxProps {
  checked?: boolean;
  onChange?: (checked: boolean) => void;
  hasInvoices: boolean;
}

/**
 * Unchecking with invoices already added asks first, since it discards them. Checking, or
 * unchecking with nothing added, switches immediately. Same copy as the in-app form.
 */
function AgainstInvoicesCheckbox(props: AgainstInvoicesCheckboxProps) {
  const { checked = true, onChange, hasInvoices } = props;
  const [confirmOpen, setConfirmOpen] = useState(false);

  function handleChange(event: onCheckBoxChange[number]) {
    const next = event.target.checked;
    if (!next && hasInvoices) {
      setConfirmOpen(true);
      return;
    }
    onChange?.(next);
  }

  function handleConfirm() {
    setConfirmOpen(false);
    onChange?.(false);
  }

  function handleCancel() {
    setConfirmOpen(false);
  }

  const Content = (
    <PopConfirmContent
      title={t.title}
      desc={t.desc}
      descStyles={{ maxWidth: "260px" }}
    />
  );

  return (
    <PopConfirm
      open={confirmOpen}
      title={Content}
      icon={false}
      placement="bottomLeft"
      okText={t.yes}
      cancelText={t.no}
      onConfirm={handleConfirm}
      onCancel={handleCancel}
      cancelButtonProps={{ type: "text" }}
    >
      <CheckBox
        design="border-design"
        style={{ width: "200px" }}
        checked={checked}
        onChange={handleChange}
      >
        {t.label}
      </CheckBox>
    </PopConfirm>
  );
}

export { AgainstInvoicesCheckbox };
